/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueryExecutionOptions } from '../../models/query-execution-options';
import { QueryResultDto } from '../../models/query-result-dto';

export interface QueryExecutionQueryDefinitionIdExecutePost$Plain$Params {
  queryDefinitionId: string;
      body?: QueryExecutionOptions
}

export function queryExecutionQueryDefinitionIdExecutePost$Plain(http: HttpClient, rootUrl: string, params: QueryExecutionQueryDefinitionIdExecutePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryResultDto>> {
  const rb = new RequestBuilder(rootUrl, queryExecutionQueryDefinitionIdExecutePost$Plain.PATH, 'post');
  if (params) {
    rb.path('queryDefinitionId', params.queryDefinitionId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QueryResultDto>;
    })
  );
}

queryExecutionQueryDefinitionIdExecutePost$Plain.PATH = '/query-execution/{queryDefinitionId}/execute';
